(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function format(n) {
    try { return n.toLocaleString('it-IT'); } catch (e) { return String(n); }
  }
  function animate(el) {
    var target = parseFloat(el.getAttribute('data-target'));
    if (isNaN(target)) return;
    if (reduce) { el.textContent = format(target); return; }
    var duration = 2200;
    var start = null;
    function tick(t) {
      if (start === null) start = t;
      var p = Math.min((t - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = format(Math.round(target * eased));
      if (p < 1) window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }
  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', 'true');
    var nums = root.querySelectorAll('[data-target]');
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nums, function (n) { n.textContent = format(parseFloat(n.getAttribute('data-target'))); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animate(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    Array.prototype.forEach.call(nums, function (n) { n.textContent = '0'; io.observe(n); });
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lux-stats]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
